import { getUrlLang } from './i18n.js'

export function slugify(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\+/g, 'plus')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

export function pageHref(page, queryParams = null) {
  const slug = slugify(page)
  const basePath =
    !slug || slug === 'home' || slug === 'index' ? '/' : `/pages/${slug}.html`
  const query = buildQueryString(withLangParam(queryParams))
  return query ? `${basePath}?${query}` : basePath
}

function withLangParam(params) {
  // 在站内链接中自动继承当前语言（除非调用方已显式提供 lang）
  const lang = typeof window !== 'undefined' ? getUrlLang() : ''
  if (!lang) return params

  if (!params) return { lang }

  if (typeof params === 'string') {
    const sp = new URLSearchParams(params.trim().replace(/^\?/, ''))
    if (!sp.has('lang')) sp.set('lang', lang)
    return sp
  }

  if (
    typeof URLSearchParams !== 'undefined' &&
    params instanceof URLSearchParams
  ) {
    const sp = new URLSearchParams(params.toString())
    if (!sp.has('lang')) sp.set('lang', lang)
    return sp
  }

  if (typeof params === 'object') {
    if ('lang' in params) return params
    return { ...params, lang }
  }

  return params
}

// Turns supported parameter shapes into a standard query string.
function buildQueryString(params) {
  if (!params) return ''

  if (typeof params === 'string') {
    return params.trim().replace(/^\?/, '')
  }

  const supportsURLSearchParams = typeof URLSearchParams !== 'undefined'
  if (supportsURLSearchParams && params instanceof URLSearchParams) {
    return params.toString()
  }

  if (typeof params !== 'object') return ''

  const collectedEntries = []
  const appendEntry = (key, value) => {
    if (value === undefined || value === null || value === '') return
    collectedEntries.push([key, String(value)])
  }

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((entry) => appendEntry(key, entry))
      return
    }
    appendEntry(key, value)
  })

  if (!collectedEntries.length) return ''

  if (supportsURLSearchParams) {
    const searchParams = new URLSearchParams()
    collectedEntries.forEach(([key, value]) => searchParams.append(key, value))
    return searchParams.toString()
  }

  return collectedEntries
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&')
}
